<template>
	<v-dialog
			:value="isViewDepartments"
			content-class="dialogWrapper"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>View department</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="fieldWrapper">
					<div class="item">
					<field
							:class-error="getError('name')"
							margin="0"
							width="100%"
							label="Department name"
							placeholder="Enter department name"
							:setInputValue="name"
							@updateInput="onInput($event, 'name')"
							is-required
					></field>
					</div>

					<div class="item">
						<field
								:class-error="getError('dispatcher')"
								margin="0"
								width="100%"
								label="Head department "
								placeholder="Select head department "
								@updateAutocomplete="onAutocomplete($event, 'dispatcher')"
								:autocompleteValue="dispatcher"
								:items="editDepartmentsUsers"
								:isClearable="false"
								item-text="name"
								item-value="dispatcher_id"
								is-autocomplete
								is-required
						></field>
					</div>

					<div class="item">
						<field
								margin="0"
								width="100%"
								label="Super head department"
								placeholder="Select super head department"
								@updateAutocomplete="onAutocomplete($event, 'dispatcherSuper')"
								:autocompleteValue="dispatcherSuper"
								:items="editDepartmentsUsers"
								:isClearable="false"
								item-text="name"
								item-value="dispatcher_id"
								is-autocomplete
						></field>
					</div>

				</div>
				<div class="main">

					<div class="item descriptionWrapper">
						<div class="label">Department duties description</div>
						<div class="description">
							<vue-editor
									ref="editor"
									v-model="description"
									placeholder="Enter department description"
									:key="descriptionKey"
							/>
						</div>
<!--						<field-->
<!--								margin="0"-->
<!--								width="100%"-->
<!--								label="Department description"-->
<!--								placeholder="Enter department description"-->
<!--								:setInputValue="name"-->
<!--								@updateInput="onInput($event, 'description')"-->
<!--								is-textarea-->
<!--						></field>-->
					</div>
					<div class="item">
						<div class="label">Department Color</div>
						<!--						hide-canvas-->
						<!--						hide-inputs-->
						<v-color-picker
								v-model="colorMod.hex"
								class="colorMod"
								hide-inputs
								show-swatches
								hide-canvas
						></v-color-picker>
					</div>

				</div>
				<div class="footer">
					<custom-btn
							text="Save"
							@updateEvent="onSave"
							custom-class="apply"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'safe'}"
					></custom-btn>
					<custom-btn
							text="Close"
							@updateEvent="onClose"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'close'}"
					></custom-btn>
				</div>
			</div>
		</div>
		<preload v-if="isPreloader"></preload>

	</v-dialog>
</template>

<script>

import Vue from 'vue';

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask';

Vue.use(VueMask);

// validation
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";

import { mapActions, mapGetters } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
export default {
	name: "ViewDepartments",
	components: {
		Preload,
		VueEditor,
	},
	computed: {
		...mapGetters([
			'editDepartmentsUsers',
			'editDepartments',
		]),
	},
	mixins: [ validationMixin ],
	props: {
		dialogFlag: String,
	},
	validations: {
		name: { required },
		dispatcher: { required }, // Добавьте валидацию для обязательного поля
	},
	data: () => ({
		content: null,
		isViewDepartments: true,
		id: null,
		dispatcher: [],
		dispatcherSuper: [],
		colorMod: { hex: '#EF0000' },
		name: null,
		isPreloader: false,
		descriptionKey: 0,
		description: '', // пусто на початку
	}),

	methods: {
		...mapActions([ 'setAlert', 'onAccountDepartmentsSave', 'onAccountDepartmentsEdit', 'onAccountDepartmentsCreate' ]),

		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
		},

		onInput({ value }, key) {
			this[key] = value;
		},
		onTime(value, key) {
			this[key] = value;
		},

		async onSave() {
			this.isPreloader = true;

			this.$v.$touch();
			if (!this.$v.$error) {
				const { name, id, dispatcher, dispatcherSuper, colorMod } = this.$data;
				const head_id = dispatcher?.dispatcher_id ?? null;
				const super_head_id = dispatcherSuper?.dispatcher_id ?? null;
				const color = colorMod.hex;

				// ✅ Отримуємо HTML-контент із редактора напряму
				const description = this.$refs.editor?.quill.root.innerHTML || '';

				if (this.dialogFlag === 'add') {
					await this.onAccountDepartmentsSave({ name, description, head_id, super_head_id, color });
				} else {
					await this.onAccountDepartmentsEdit({ name, description, id, head_id, super_head_id, color });
				}

				this.$emit('updateClose');
				this.$emit('updateList');
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}

			this.isPreloader = false;
		},

		onClose() {
			this.$emit('updateClose');
		},

		getError(key) {
			return this.$v && this.$v[key] && this.$v[key].$error;
		},
	},
	async mounted() {
		this.isPreloader = true;

		if (this.dialogFlag === 'add') {
			await this.onAccountDepartmentsCreate();
			this.name = null;
			this.description = '';
			this.dispatcher = [];
			this.dispatcherSuper = [];
			this.id = null;
			this.colorMod = { hex: '#EF0000' };
		} else {
			this.name = this.editDepartments.name;
			this.dispatcher = { dispatcher_id: this.editDepartments.head_id };
			this.dispatcherSuper = { dispatcher_id: this.editDepartments.super_head_id };
			this.id = this.editDepartments.id;
			this.colorMod = this.editDepartments.color
				? { hex: this.editDepartments.color }
				: { hex: '#EF0000' };

			// 👇 Вставка HTML напряму в редактор
			this.description = ''; // очищаємо, щоб уникнути конфлікту з v-model
			this.descriptionKey++; // змушує редактор перерендеритися

			this.$nextTick(() => {
				const editor = this.$refs.editor?.quill;
				if (editor && this.editDepartments.description) {
					editor.root.innerHTML = this.editDepartments.description;
				}
			});
		}

		this.isPreloader = false;
	}
};
</script>
<style>
@import "../ViewVersion/vueEditor.scss";
</style>
<style scoped lang="scss">
@import "../ViewVersion/ViewVersion";

.dialogWrapper {
	.dialogMain {
		.main {
			display: grid;
			grid-template-columns: 3fr 1fr ;
			grid-gap: 10px;
			margin-bottom: 10px;
			@media screen and (max-width: 1200px) {
				grid-template-columns: 3fr;
			}
			@media screen and (max-width: 768px) {
				grid-template-columns: 1fr;
			}
			@media screen and (max-width: 390px) {
				grid-template-columns: 1fr;
			}
		}
	}
}

</style>
